<script lang="ts">
	import Icon from '../../../basic/Icon.svelte';
	import type { SmallDocumentRepresentation } from '../../../types/DocumentTypes';

	interface Props {
		item: SmallDocumentRepresentation;
		selected: boolean;
		onClick: (e: MouseEvent) => void;
		onDblCLick: (e: MouseEvent) => void;
	}

	let { item = $bindable(), selected, onClick, onDblCLick }: Props = $props();
</script>

<button
	onclick={onClick}
	ondblclick={onDblCLick}
	class:selected
	class="p-6 bg-white dark:bg-dark-400 rounded-md text-left border-2 border-transparent
	 hover:border-secondary-200 dark:hover:border-secondary-500 selected:border-secondary-200 dark:selected:border-secondary-500"
>
	<div class="h-full">
		<!--Folder-->
		<div class="flex items-center gap-2">
			<Icon name="folder" />

			<p class="truncate grow">
				{item.documentInformation.folder.shortName} / {item.documentInformation.folder.name}
			</p>
		</div>

		<!--Type-->
		<div class="flex items-center gap-2 mt-2">
			<div class="w-2 h-2 rounded {item.isRegie ? 'bg-primary-200' : 'bg-secondary-200'}"></div>
			<p>
				{item.type}
			</p>
		</div>

		<!--short name, total-->
		<div class="flex justify-between mt-4">
			<p>
				{item.shortName}
			</p>
		</div>

		<!--Name-->
		<p class="font-bold mt-2 text-ellipsis overflow-hidden">
			{item.name}
		</p>
	</div>
</button>
